<template>
  <div class="app-body" id="app-body" :class="[bodyClass, {'scrolled': isScrolled}]" :style="zoomToFitScreen">
    <router-view/>
  </div>
</template>

<script>
  import store from '@/store'
  import lib from '@/library'
  import { localeProperties } from './library/cdu/translations'

  import Screen from '@/components/mixins/Screen'
  import CssClasses from '@/components/mixins/CssClasses'

  export default {
    mixins: [
      Screen,
      CssClasses
    ],

    data () {
      return {

      }
    },

    computed: {
      cduState () {
        return store.getters['cduState/getScreenState']
      },
      zoomToFitScreen () {
        var appWidth = 1920
        var appHeight = 1080
        var zoom = 1
        var deviceResolution = this.screenWidth

        if (this.cduState === 'banner') {
          return {}
        }

        if (deviceResolution > 0) {
          zoom = deviceResolution / appWidth
        }

        return {
          width: appWidth.toString().concat('px'),
          height: appHeight.toString().concat('px'),
          transform: 'scale(' + zoom + ')',
          transformOrigin: 'top left'
        }
      }
    },

    methods: {
      openLiveEventsSocket () {
        var self = this
        self.lib = lib

        store.dispatch('livebettingState/calculateLocalClockOffsetInSeconds').then(() => {
          self.lib.WebSocketLiveService.startService(() => {
            console.log('WebSocketService - Cannot connect to server.')
          })
        })
      }
    },

    created () {
      this.$moment.locale(localeProperties.getDefaultLocale)
    },
    mounted () {
      this.openLiveEventsSocket()
    },

    destroyed () {
      this.lib.WebSocketLiveService.stopService()
    },

    name: 'App'
  }
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/App.vue